import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, delay } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../../environments/environment";
import { ParkingZone, ParkingZoneDto } from "../../../models/parking/parking-zone.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperParkingZoneService } from '../../../mappers/parking/mapper-parking-zone.service';

@Injectable({
    providedIn: 'root',
})
export class ApiParkingZoneService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperParkingZoneService
    ) { }

    getParkingZones(): Observable<ParkingZone[]> {
        // MOCK DATA directly answering the requested image
        const mockData: ParkingZoneDto[] = [
            { id: 1, name: 'โซน A', floor: 'ชั้น 1-4', parkingType: 'อาคารจอดรถยนต์', lot: 1295, isOnline: true },
            { id: 2, name: 'โซน B', floor: 'ชั้น 1-4', parkingType: 'อาคารจอดรถมอเตอร์ไซค์', lot: 235, isOnline: true }
        ];

        return of(mockData).pipe(
            delay(400),
            map(dtos => dtos.map(dto => this.mapper.mapFromDto(dto)))
        );

        /* 
        // Real API Call
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<ParkingZoneDto[]>(
            '/backoffice/GetParkingZone',
            'GET',
            this.baseUrl,
            {
                labelLog: 'GetParkingZone',
                token: token,
                headerOnly: false,
                isConsoleLog: true
            }
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapFromDto(dto)))
        );
        */
    }
}
